import { render, staticRenderFns } from "./HorizontalSplitPane.vue?vue&type=template&id=fdbafaf2&scoped=true&"
import script from "./HorizontalSplitPane.vue?vue&type=script&lang=js&"
export * from "./HorizontalSplitPane.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalSplitPane.vue?vue&type=style&index=0&id=fdbafaf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbafaf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
